import { Download } from "lucide-react";
import { toast } from "sonner";
import { useInstallPrompt } from "../../hooks/useInstallPrompt";

export const InstallButton = ({ className = "", variant = "nav", label = "Install app", onDone }) => {
  const { canInstall, ios, hasPrompt, promptInstall } = useInstallPrompt();

  if (!canInstall) return null;

  const handle = async () => {
    if (hasPrompt) {
      await promptInstall();
    } else if (ios) {
      toast("Install Old Geezer", {
        description: "Tap the Share icon, then \u201cAdd to Home Screen\u201d.",
        duration: 8000,
      });
    }
    onDone?.();
  };

  const base =
    variant === "solid"
      ? "inline-flex items-center gap-2 bg-blood text-white px-5 py-3 font-mono text-xs tracking-[0.2em] uppercase transition-transform duration-300 hover:-translate-y-0.5"
      : variant === "compact"
      ? "inline-flex items-center gap-1.5 border border-white/20 hover:border-blood px-3 py-2 font-mono text-[10px] tracking-[0.2em] uppercase transition-all duration-300 text-bone"
      : "inline-flex items-center gap-2 border border-white/20 hover:border-blood hover:bg-blood px-5 py-2.5 font-mono text-[11px] tracking-[0.25em] uppercase transition-all duration-300 text-bone";

  return (
    <button data-testid="install-app-btn" onClick={handle} className={`${base} ${className}`}>
      <Download className="h-3.5 w-3.5" />
      {label}
    </button>
  );
};
